import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/node_modules/@shc/ui/dist/lib/components/Button/Button.js");
;
import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/app/node_modules/@shc/ui/dist/lib/components/Icon/Icon.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/cms/blocks/cta-background-block.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/cms/components/expandable-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/cms/components/video-player.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/contentful-image.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/foundation-newsletter-signup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/media-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/news-share-butons.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/newsletter-signup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/page-analytics-wrapper.tsx");
